module.exports = {
  serverUrl: 'https://dev.wisemodel.cn/gateway', // 接口地址
  imageServerUrl: 'https://dev.wisemodel.cn/image-proxy', // 图片服务器地址前缀
  fileServerUrl: 'https://dev.wisemodel.cn/file-proxy', // 文件服务器地址前缀https://dev.wisemodel.cn
  defaultThemeColor: '#571482',
  baseUrl: ''
}
